/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

const styles = {
  statusCard: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--cds-spacing-150);
    padding: var(--cds-spacing-100);
    border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    border-radius: var(--cds-border-radius-100);
  `,
};

export type StatusCardProps = { title: string; detail: string; detailColor?: 'error'; icon: React.ReactElement };

/** A single bordered row: title + detail on the left, a status icon on the right. */
const StatusCard = ({ title, detail, detailColor, icon }: StatusCardProps) => (
  <div css={styles.statusCard}>
    <div>
      <Typography2 component="p" variant="subtitleMedium">
        {title}
      </Typography2>
      <Typography2 component="p" variant="bodySecondary" color={detailColor}>
        {detail}
      </Typography2>
    </div>
    {icon}
  </div>
);

export default StatusCard;
